import each from 'lodash/each'

// .animation-element for backwards-compat
const inViewElementSelector = '.animation-element, [data-in-view]'
const inViewClassname = 'in-view'
const inViewOnceClassname = 'in-view-once'

function handleInView(entries) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add(inViewClassname)
      entry.target.classList.add(inViewOnceClassname)
    } else {
      entry.target.classList.remove(inViewClassname)
    }
  })
}

let observers = []

function setupInViewObserver(el) {
  if (el.hasAttribute('data-inview-initialized')) {
    return
  }
  const observer = new IntersectionObserver(handleInView, {
    threshold: 0,
  })
  observer.observe(el)
  observers.push(observer)
  el.setAttribute('data-inview-initialized', '1')
}

function setupInViewObservers(container) {
  if (!container) {
    return
  }

  // Initialize existing elements:

  const existingEls = container.querySelectorAll(inViewElementSelector)
  if (existingEls.length) {
    each(existingEls, (el) => {
      setupInViewObserver(el)
    })
  }

  // Observe new elements:

  const observer = new MutationObserver((mutations) => {
    each(mutations, (mutation) => {
      each(mutation.addedNodes, (node) => {
        if (node.nodeType !== 1) {
          return
        }

        const els = node.querySelectorAll(inViewElementSelector)
        if (!els.length) {
          return
        }

        each(els, (el) => {
          setupInViewObserver(el)
        })
      })
    })
  })

  observer.observe(container, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false,
  })
}

function destroyInViewObservers() {
  observers.forEach((observer) => observer.disconnect())
  observers = []
}

export { setupInViewObservers, destroyInViewObservers }
